export const types = {
  PUSH_NOTIFICATION: 'notifications/push',
};

export const addNewNotification = (message, category, link) => ({
  type: types.PUSH_NOTIFICATION,
  message,
  category,
  link,
});
